export default __webpack_public_path__ + "static/media/logo.cb2263e4.svg";